import define from '@ingka/webc-tools';
import { Loading } from './src/Loading.js';
import { LoadingBall } from './src/LoadingBall.js';
import { LoadingLinear } from './src/LoadingLinear.js';
export { Loading, LoadingBall, LoadingLinear };
export const loadingTagName = define('loading', Loading);
export const loadingBallTagName = define('loading-ball', LoadingBall);
export const loadingBarTagName = define('loading-linear', LoadingLinear);
